export default __webpack_public_path__ + "c4c41cc393afaf4b5fbf3323599a13cf.png";